import React from "react";
import Gallery from "react-photo-gallery";
import styles from "./Features.module.scss";
import Layout from "../../layouts/Layout/Layout";
import THEME from "../../../state/theme";


export default ({ data = [] }) => {

  const featuresList = <Gallery photos={data} />

  return (
    <Layout
      style={{
        background: "rgb(240,240,240)",
      }}
      padding
    >
      <div className="layout-header">
        <span className="subtitle" style={{ color: THEME.color }}>
          Images
        </span>
        <h2>Things end but memories last forever.</h2>
        {/* <p>
          Energistically predominate high-payoff alignments whereas maintainable
          materials timely deliverables. Synergistically leverage other's
          holistic mindshare via high-payoff expertise.
        </p> */}
      </div>
      <div className={styles.galleryview}>
        {featuresList}
      </div>
      {/* <div className={["layout-footer", styles.footer].join(" ")}>
        <span>
          <b style={{ color: THEME.color }}>Let's start do business.</b>
        </span>
        <span>Make arrangement and get discount.</span>
      </div> */}
    </Layout>
  )
}